import React, { useRef, useState } from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Stack from "@mui/joy/Stack";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { Button } from "primereact/button";
import { Grid } from "@mui/material";
import { TabPanel, TabView } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Dropdown } from "primereact/dropdown";
import { PPEEmployeeUpdate } from "../../../service/ppeService";
import ImageS3Upload from "../../../components/ImageS3Upload";

export default function EmployeePPEUpdate(modalProps: any) {
  const record = modalProps?.record;

  const [name, setName] = useState(record?.name || "");
  const [photo, setPhoto] = useState(record?.photo || "");
  const [size, setSize] = useState(record?.size || "");

  async function updatePPE() {
    PPEEmployeeUpdate(record.id, {
      size
    }).then((r: any) => {
      modalProps.toast.current.show({
        severity: "success",
        summary: "PPE Updated Successfully",
        life: 3000,
      });
      modalProps.setVisible(null);
      modalProps.setGlobalLoading(false);
      modalProps.setReload(!modalProps.reload);
    });
  }

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormControl>
            <ImageS3Upload
              photo={photo}
              setPhoto={setPhoto}
              disabled={true}
            />
          </FormControl>
        </Grid>
        <Grid item xs={8}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl sx={{ flexGrow: 1 }}>
                <FormLabel>
                  Name
                </FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <InputText
                    value={name}
                    disabled={true}
                    onChange={(e) => setName(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                  />
                </FormControl>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>Size</FormLabel>
                <InputText
                  value={size}
                  onChange={(e) => setSize(e.target.value)}
                  type="text"
                  className="p-inputtext-sm PrimeSmallInput"
                />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <br />
      <br />
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
          <Button
            name="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => updatePPE()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
